import React from "react"

import Layout from "../components/layout/Layout"
import Hero from "../components/shared/Hero"
import ThreeBlock from "../components/shared/ThreeBlock"
import CtaBanner from "../components/shared/CtaBanner"

import { SeoMetaType, HeaderType, ThreeCard, CtaBannerType } from "../types"

type ThankYouProps = {
  seoMeta: SeoMetaType
  header: HeaderType[]
  learnMoreTitle: string
  cards: ThreeCard[]
  pathname: string
  ctaBanner: CtaBannerType
}

const ThankYou = ({
  seoMeta,
  header,
  learnMoreTitle,
  cards,
  pathname,
  ctaBanner,
}: ThankYouProps) => {
  return (
    <Layout contentClass="ThankYouPage" seoMeta={seoMeta} pathname={pathname}>
      <Hero header={header} />
      <ThreeBlock title={learnMoreTitle} cards={cards} />
      {ctaBanner && <CtaBanner ctaBanner={ctaBanner} />}
    </Layout>
  )
}

export default ThankYou
